import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { combineLatest, ReplaySubject, timer } from 'rxjs'
import { IForgotPassword } from '../../models/forgot-password'
import { map, startWith, takeUntil } from 'rxjs/operators'
import { ISetPasswordFormData } from '../../models/set-password-form-data'
import { IBaseForm } from '../../models/base-form'


@Component({
  selector: 'adex-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: [ './set-password.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SetPasswordComponent implements IBaseForm<ISetPasswordFormData> {

  @Input() public model: IDynamicFormModel
  @Output() public submitForm: EventEmitter<ISetPasswordFormData> = new EventEmitter()

  public validForm$: ReplaySubject<boolean> = new ReplaySubject(1)
  public changeForm$: ReplaySubject<IForgotPassword> = new ReplaySubject(1)

  public disabledButton$ = combineLatest([
    this.validForm$,
    this.changeForm$.pipe(map(data => data.newPassword === data.confirmPassword))
  ])
    .pipe(
      map(([ validForm, accept ]) => !(validForm && accept)),
      startWith(false)
    )

  public async onSubmit(): Promise<void> {
    const password = await this.changeForm$.pipe(takeUntil(timer(0))).toPromise()
    if (!password) return
    this.submitForm.emit({ password: password.newPassword })
  }

}
